// extracted by mini-css-extract-plugin
export var dataCell = "_os-2";
export var dataRow = "_os-0";
export var headerRow = "_os-1";